
import React, { useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Helmet } from 'react-helmet';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import ModelSearchModal from './ModelSearchModal';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
const ModelList = ({ history }) => {

    const modelModalRef                 =       useRef(null);
    const modelUrl                      =       BACKOFFICE_BASE_URL + '/model'

    const initManufacturerModal         =       () => {
        if (modelModalRef.current) {
            modelModalRef.current.initModalHandler();
        }
    };
    const [listingLoading, setListingLoading]                        =      useState(false);
    const [modelListing, setModelListing]                            =      useState([]);
    const [listingMeta, setListingMeta]                              =      useState(null);
    const [submittedModelFilterForm, setSubmittedModelFilterForm]    =      useState({});
    const [formSearchedElems, setFormSearchedElems]                  =      useState([]);

    const permissions                   =   useSelector(state => state.app.acl_info?.permissions || []);
    const access_token                  =   useSelector(state => state.auth.access_token);

    useEffect(() => {
        loadListingTblData(1);
    }, []);

    const loadListingTblData = (page = 1, searchParams = submittedModelFilterForm) => {
        setListingLoading(true);
        const params = { page: page, per_page: 100 };
        if (searchParams && Object.keys(searchParams).length > 0) {
            Object.keys(searchParams).forEach(key => {
                if (searchParams[key] && searchParams[key].toString().trim() !== '') {
                    params[key] = searchParams[key];
                }
            });
        }
        HttpAPICall.withAthorization('GET', modelUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setModelListing(respData.data);
            setListingMeta({
                from        :   respData.from,
                to          :   respData.to,
                total       :   respData.total,
                last_page   :   respData.last_page,
                per_page    :   respData.per_page,
                current_page:   respData.current_page
            });
        }).then(() => setListingLoading(false));
    };

    const deleteModel = (id) => {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this permanently?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', modelUrl + '/delete/' + id, access_token,{},{},(resp) => {
                    toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    loadListingTblData(1)
                });
            }
        });
    }

    const addModelFormInit = () => {
        history.push('/add_model');
    };

    const editModelInit = (item) => {
        history.push({ pathname: `/add_model`, state: { editModelData: item } });
    };

    const handleSearch = (params, searchedElems) => {
        setFormSearchedElems(searchedElems);
        setSubmittedModelFilterForm(params);
        loadListingTblData(1, params);
    };
    const modelSearchClear = () => {
        setFormSearchedElems([]);
        setSubmittedModelFilterForm({});
        if (modelModalRef.current) {
            modelModalRef.current.resetForm();
        }
        loadListingTblData(1, {});
    };

    const modelJsx = () => {
        return (
            <Ax>
                <div className="page_title row m0">
                    <div>
                        <h3>Model List</h3>
                        <div className="text-end mt15">
                            <Ax>
                                {permissions.includes('asset_model_add') && (
                                    <button type="button" className="btn btn-primary" onClick={addModelFormInit}>New</button>
                                )}
                                <button type="button" className="btn btn-secondary" onClick={initManufacturerModal} disabled={listingLoading}>
                                    <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </Ax>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{modelListingJsx()}</div>
                    </div>
                </div>
            </Ax>
        );
    };

    const modelListingJsx = () => {
        return (
            <Ax>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={modelSearchClear} />
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            <Ax>
                                <th scope="col" style={{ width: "5%" }}>S.No</th>
                                <th scope="col" style={{ width: "30%" }}>Name</th>
                                <th scope="col" style={{ width: "30%" }}>Manufacturer</th>
                                <th scope="col" className="text-center" style={{ width: "28%" }}>Remarks</th>
                                <th scope="col" className="text-center" style={{ width: "7%" }}>Action</th>
                            </Ax>
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="5"><Loader /></td></tr>)
                            : (modelListing && modelListing.length > 0
                                ? (modelListing.map((item, index) => (
                                    <tr key={index}>
                                        <Ax>
                                            <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                            <td>{item.model ? item.model : "-"}</td>
                                            <td>{item.manufacturer ? item.manufacturer.manufacturer : "-"}</td>
                                            <td>{item.description ? item.description : "-"}</td>
                                            <td className='text-center'>
                                                <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    {permissions.includes('asset_model_edit') && (
                                                        <li onClick={() => editModelInit(item)}><a className="dropdown-item" role="button">Edit</a></li>
                                                    )}
                                                    {permissions.includes('asset_model_delete') && (
                                                        <li onClick={() => deleteModel(item.id)}><a className="dropdown-item" role="button">Delete</a></li>
                                                    )}

                                                </ul>
                                            </td>
                                        </Ax>
                                    </tr>
                                )))
                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1 , submittedModelFilterForm)}
                />
            </Ax>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Model Listing</title></Helmet>
            {modelJsx()}
            <ModelSearchModal ref={modelModalRef} onSearch={handleSearch}
                initialSearchForm={submittedModelFilterForm} />
        </ApplicationLayout>
    );
};

export default ModelList;
